module.exports = __webpack_public_path__ + "static/media/pepboys.b2025b8b.svg";